import { useEffect, useState } from 'react';
import { Monitor } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';

const MIN_WIDTH = 1024; // Minimum recommended width (tablets/small laptops)
const MIN_HEIGHT = 600; // Minimum recommended height
const STORAGE_KEY = 'resolutionWarningDismissed';

export function ResolutionWarningModal() {
  const [showWarning, setShowWarning] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkResolution = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isDismissed = localStorage.getItem(STORAGE_KEY) === 'true';

      // Show warning if resolution is too small and user hasn't dismissed it
      if ((width < MIN_WIDTH || height < MIN_HEIGHT) && !isDismissed) {
        setShowWarning(true);
        setIsOpen(true);
      } else {
        setShowWarning(false);
        setIsOpen(false);
      }
    };

    // Check on mount
    checkResolution();

    // Check on window resize
    window.addEventListener('resize', checkResolution);

    return () => {
      window.removeEventListener('resize', checkResolution);
    };
  }, []);

  const handleProceedAnyway = () => {
    // Remember user's choice
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsOpen(false);
    setShowWarning(false);
  };

  if (!showWarning) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={() => {}} modal={true}>
      <DialogContent
        className="max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Monitor className="w-5 h-5 text-amber-600" />
            <DialogTitle>Resolution Notice</DialogTitle>
          </div>
          <DialogDescription>
            Patent Loop is designed for larger screen resolutions
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <p className="text-sm text-gray-700">
            Your current screen resolution ({window.innerWidth} × {window.innerHeight}) is below
            the recommended minimum of {MIN_WIDTH} × {MIN_HEIGHT} pixels.
          </p>
          <p className="text-sm text-gray-700">
            Some features and layouts may not display optimally on smaller screens.
            For the best experience, we recommend using a desktop or laptop computer with a larger display.
          </p>
          <div className="pt-2">
            <Button
              onClick={handleProceedAnyway}
              className="w-full"
            >
              Proceed Anyway
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
